import React from "react";
import uploadanimation from "./upload-animation.json";
import Lottie from "react-lottie-player";
import { isEmpty } from "lodash";
import ProgressBand from "../../ProgressBand/ProgressBand";
function loading({ progressbar, progress }) {
  return (
    <>
      <div className="flex items-center justify-center h-[100vh] w-[100%] flex-col">
        <Lottie
          loop
          animationData={uploadanimation}
          play
          style={{ width: 173, height: 173 }}
        />
        <p className="text-gray-400 text-regular mb-[10px]">Uploading</p>
        <p className="text-gray-400 w-[300px] text-small  text-center">
          Your entry is getting uploaded. It might take some time to finish.
          Please don't close or refresh the window.
        </p>
        {!isEmpty(progress) &&
          progress?.map((individualFile, index) => {
            return (
              <div className="w-full px-[20px]">
                <div className="mt-[22px]">
                  <p className="text-regular mb-[10px] text-gray-400">
                    Uploading File {index + 1}
                  </p>
                  <ProgressBand value={individualFile} />
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default loading;
